<template>
  <Field
    v-slot="{ errors }"
    :as="validationTag"
    :modelValue="content"
    :name="id"
    :rules="rules"
    :validateOnBlur="validateOnBlur"
    :validateOnModelUpdate="validateOnModelUpdate"
    :validateOnInput="validateOnInput"
    :validateOnChange="false"
    class="bordered-textarea"
    :class="{
      'bordered-textarea_without-resize': !resize
    }"
  >
    <label
      v-if="label.length"
      :for="id"
      class="body-text body-text-medium-400"
    >
      <slot name="label">
        {{ label }}

        <ClueTooltip
          v-if="tooltip"
          :text="tooltipText"
        />
      </slot>
    </label>

    <textarea
      :id="id"
      :value="modelValue"
      rows="1"
      :placeholder="placeholder"
      class="custom-scroll"
      :class="{ 'is-error': errors[0] || customErrorMessage }"
      :readonly="readonly"
      :maxlength="maxlength"
      @input="handleInput($event.target.value)"
      @mousedown="$event.stopPropagation()"
      @blur="$emit('onBlur')"
    />

    <icon
      v-if="resize"
      data="@icon/resize.svg"
      width="9"
      height="9"
      color="#7D92A7"
      class="bordered-textarea__icon"
    />
    <div
      v-if="addButtons"
      class="bordered-textarea__buttons"
    >
      <button
        type="button"
        class="secondary-button secondary-button_small btn"
        @click="onCancel"
      >
        Cancel
      </button>

      <button
        type="button"
        :disabled="!content.length"
        class="primary-button primary-button_small btn"
        @click="onSave"
      >
        Save
      </button>
    </div>
    <span
      v-if="errors[0] || customErrorMessage"
      class="error-text bordered-input__error"
      :class="{ 'error-text-small': isSmallErrorText }"
    >
      {{ errors[0] ?? customErrorMessage }}
    </span>
  </Field>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Emit, Prop } from "vue-property-decorator"
import { Field } from "vee-validate"

import ClueTooltip from "@/components/ClueTooltip/index.vue"

@Options({
  name: "BorderedTextarea",
  components: {
    ClueTooltip,
    Field
  }
})
export default class BorderedTextarea extends Vue {
  @Prop({ default: "" }) readonly value: string
  @Prop({ default: "" }) readonly label: string
  @Prop({ default: "" }) readonly id: string
  @Prop({ default: "" }) readonly placeholder: string
  @Prop({ default: false }) readonly tooltip: boolean
  @Prop({ default: "" }) readonly tooltipText: string
  @Prop({ default: "" }) readonly modelValue: string
  @Prop({ default: false }) readonly addButtons: boolean
  @Prop({ default: true }) readonly resize: boolean
  @Prop({ default: false }) readonly readonly: boolean
  @Prop({ default: "300" }) readonly maxlength: string
  @Prop({ default: "div" }) validationTag: string
  @Prop({ default: "" }) readonly rules: () => boolean | string
  @Prop({ default: true }) validateOnBlur: boolean
  @Prop({ default: false }) validateOnModelUpdate: boolean
  @Prop({ default: false }) validateOnInput: boolean
  @Prop({ default: true }) isSmallErrorText: boolean
  @Prop({ default: "" }) customErrorMessage: string

  get content() {
    return this.modelValue
  }

  set content(value) {
    this.$emit("update:modelValue", {
      value,
      id: this.id
    })
  }

  @Emit("onCancel")
  onCancel() {
    this.content = ""
  }

  @Emit("onSave")
  onSave() {}

  handleInput(value) {
    this.content = value
  }
}
</script>
